import React, { useState, useEffect } from 'react';
import { Fragment } from "react";
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles({
    headerCell: {
        fontSize: '12px',
        fontWeight: 'bold'
    },
    cell: {
        fontSize: '12px'
    }
});

const BambooHr = () => {
    const [jobData, setJobData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch('https://boards-api.greenhouse.io/v1/boards/nationalresearchgroup/jobs?content=true')
            .then(response => response.json())
            .then(data => {
                var organizeddata = [];
                data.jobs.map(function (job) {
                    var item = {
                        absolute_url: job.absolute_url,
                        location: job.location,
                        title: job.title,
                        offices: job.offices
                    }

                    var dept = job.departments[0]; // there should only be a single department per job
                    var lookup = dept.name;
                    if (typeof (organizeddata[lookup]) === 'undefined') {
                        organizeddata[lookup] = {
                            info: dept,
                            items: [item]
                        };
                    } else {
                        organizeddata[lookup].items.push(item);
                    }
                });
                var transformedData = [];
                for (const property in organizeddata) {
                    transformedData.push(organizeddata[property]);
                }
                setJobData(transformedData);
                setLoading(false);
            });
    }, []);

    const classes = useStyles();

    let contents;
    if (loading) {
        contents = (
            <div className="loading">
                <strong>Loading...</strong>
            </div>
        );
    }
    else if (!jobData.length) {
        contents = (
            <h2>No current job openings</h2>
        );
    }
    else {
        contents = (
            <Grid container direction="row" justify="center" alignItems="center">
                <Grid item xs={12} md={8} alignItems="center">
                    <TableContainer>
                        <h2>Current Job Openings</h2>
                        <Table size="small" aria-label="spanning table">
                            <TableHead>
                                <TableRow>
                                    <TableCell className={classes.headerCell}>Team</TableCell>
                                    <TableCell className={classes.headerCell}>Location(s)</TableCell>
                                    <TableCell className={classes.headerCell}>Job Title</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {jobData.map((office) => (
                                    office.items.map((job, i) => (
                                        <TableRow key={office.info.id}>
                                            {i == 0 && <TableCell className={classes.headerCell} rowSpan={office.items.length}>{office.info.name}</TableCell>}
                                            <TableCell className={classes.cell}>{job.location.name}</TableCell>
                                            <TableCell className={classes.cell}><a key={job.absolute_url + i} href={job.absolute_url}>{job.title}</a></TableCell>
                                        </TableRow>
                                    ))))
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
        );
    }

    return (
        <div className="row BambooHr" id="careers">
            <div className="col-xs-16">
                <div id="grnhse_app">
                    {contents}
                </div>
            </div>
        </div>
    );
};

export default BambooHr;
